import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactElement, ReactNode } from "react";
import { useState } from "react";

export interface ClmQueryProviderProps {
  /** Optional so callers may pass children positionally via createElement. */
  children?: ReactNode;
  client?: QueryClient;
}

export function createClmQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          if (failureCount >= 2) {
            return false;
          }

          if (error instanceof Response && error.status >= 400 && error.status < 500) {
            return false;
          }

          return true;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export function ClmQueryProvider({ children, client }: ClmQueryProviderProps): ReactElement {
  const [queryClient] = useState(() => client ?? createClmQueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
